/**
 * Returns a function which is called at most once per timeoutMs. The final
 * call is guaranteed to happen.
 */
export const throttle = (callback: () => any, timeoutMs: number) => {
  let isCallable = true;
  let isQueued = false;

  const throttledFn = () => {
    if (isCallable) {
      isCallable = false;
      setTimeout(() => {
        isCallable = true;
        if (isQueued) {
          isQueued = false;
          throttledFn();
        }
      }, timeoutMs);
      callback();
    } else {
      isQueued = true;
    }
  };

  return throttledFn;
};
